export const ASSESSMENT_REPORT_HOBBIES = [
  { id: 1, name: 'Reading' },
  { id: 2, name: 'Sports' },
  { id: 3, name: 'Music' },
  { id: 4, name: 'Traveling' },
  { id: 5, name: 'Gaming' },
  { id: 6, name: 'Cooking' },
  { id: 7, name: 'Drawing / Art' },
  { id: 8, name: 'Dancing' },
  { id: 9, name: 'Photography' },
  { id: 10, name: 'Writing' },
  { id: 11, name: 'Coding / Programming' },
  { id: 12, name: 'Fitness / Gym' },
  { id: 13, name: 'Yoga' },
  { id: 14, name: 'Gardening' },
  { id: 15, name: 'Movies / Watching Shows' },
  { id: 16, name: 'Volunteering' },
  { id: 17, name: 'Other' },
];

export const ASSESSMENT_REPORT_AMBITION = [
  { id: 1, name: 'Software Engineer' },
  { id: 2, name: 'Doctor' },
  { id: 3, name: 'Engineer' },
  { id: 4, name: 'Scientist' },
  { id: 5, name: 'Teacher' },
  { id: 6, name: 'Entrepreneur' },
  { id: 7, name: 'Pilot' },
  { id: 8, name: 'Artist / Designer' },
  { id: 9, name: 'Musician' },
  { id: 10, name: 'Actor / Performer' },
  { id: 11, name: 'Lawyer' },
  { id: 12, name: 'Civil Servant (IAS/IPS)' },
  { id: 13, name: 'Nurse / Healthcare Professional' },
  { id: 14, name: 'Athlete / Sports Professional' },
  { id: 15, name: 'Business Professional' },
  { id: 16, name: 'Chef' },
  { id: 17, name: 'Writer / Journalist' },
  { id: 18, name: 'Digital Creator / Influencer' },
  { id: 19, name: 'Other' },
];
